import React from 'react';

import QuizCountdown from 'containers/Quiz/Countdown';

import LoversResults from '../LoversResults';

import Gender from './Gender';
import Length from './Length';
import Scenario from './Scenario';
import Sounds from './Sounds';
import Tone from './Tone';

export const QUIZ_ROUTE = 'lovers-onboarding';
export const LOVERS_TRACKING = 'lovers-onboarding';

export const QUIZ_STEPS = [
  () => <Gender />,
  () => <Tone />,
  () => <Scenario />,
  () => <Sounds />,
  () => <Length />,
  () => <QuizCountdown trackingUrl={`${QUIZ_ROUTE}/countdown`} />,
  () => <LoversResults />,
];
